export function getMcDSignInURL(origin = 'MYQ_WEB') {
  const userPoolIdToSubdomain: Record<string, string> = {
    'us-east-1_OdhPNFLDP': 'sso',
    'us-east-1_0AfpdCgWV': 'staging',
    'us-east-1_IF8z2Cwhi': 'dev',
  };

  const key = import.meta.env.VITE_APP_USER_POOL_ID ?? '';

  const subDomain = userPoolIdToSubdomain[key] ?? 'sso';

  // console.log({
  //   key,
  //   subDomain,
  // });

  let fullOrigin = origin
  const urlEnv = import.meta.env.VITE_APP_URL_ENV ?? '';
  if(urlEnv && urlEnv.toLowerCase() === 'qa') {
    fullOrigin = `${origin}/qa`;
  }
  return `https://api.${subDomain}.myqsrsoft.com/eid_login?qsr_origin=${fullOrigin}`;
}
